import { get } from '.';

export function GetEvents(organizationID, options = {}) {
	return get<any>("/app/api/organizations/" + (organizationID || 0).toString() + "/events", options);
}